import styled from 'styled-components'

export const Container = styled.div`
  overflow: hidden;
`

export const HeaderRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8};
`

export const HeaderCell = styled.div`
  min-width: 170px;

  &:nth-child(2) {
    min-width: 230px;
  }
`

export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`

export const Row = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8};

  &:nth-child(odd) {
    background-color: ${props => props.theme.colors.disabled.surface};
  }
`

export const Cell = styled.div`
  min-width: 170px;
  display: flex;
  align-items: center;

  &:nth-child(2) {
    min-width: 230px;
  }
`

export const AmountCell = styled.div`
  min-width: 170px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
